<template>
  <div class="infoGES p-4 mb-4">
    <div class="d-flex justify-content-between">
      <div>
        <label class="body_bold" style="color: #607d8b">
          GES
          <span v-if="ges.type == 'administrative'">Administrativo</span>
          <span v-else>Operativo</span> </label
        ><label class="body_bold ml-2 mr-2" style="color: #5d5fef"> / </label>
        <label class="body_bold">{{ ges.name }}</label>
      </div>
      <div class="d-flex" v-if="isVisible">
        <button
          @click.prevent="editGes"
          class="button-secundary mr-5"
          :disabled="loading"
          style="
            width: 126px;
            height: 32px;
            margin-left: auto;
            margin-right: auto;
            border-radius: 4px;
          "
        >
          <b-overlay :show="getProcessingEmployees" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <span style="width: 80%">Editar Ges</span>
            <span class="icon-pencil ml-2" style="width: 10%"> </span>
          </b-overlay>
        </button>
        <button
          @click.prevent="deleteItem"
          class="button-delete"
          :disabled="loading"
          style="
            border-radius: 4px;
          "
        >
          <b-overlay :show="getProcessingEmployees" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <span>Eliminar Ges</span>
            <img
              class=""
              :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
            />
          </b-overlay>
        </button>
      </div>
      <br />
    </div>
    <div class="linea"></div>
    <div class="d-flex flex-nowrap numbersGES col-12 p-0 mt-4">
      <div class="col-ms-3 ml-2 p-2 card-color">
        <img
          class="centerImg1 ml-2 mt-2"
          src="@/assets/images/icons/people.svg"
        />

        <div class="align-items-center mt-1">
          <div class="row">
            <div class="col">
              <span class="table-value" style="font-size: 1.4rem"
                >Total personas</span
              >
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h3 class="font-weight-bold m-0">
                {{ ges.total_employees }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-ms-3 ml-3 p-2 card-color gray">
        <img
          class="centerImg1 ml-2 mt-2"
          src="@/assets/images/icons/stethoscope.svg"
        />
        <div class="align-items-center mt-1">
          <div class="row">
            <div class="col">
              <span class="table-value" style="font-size: 1.4rem"
                >Casos enfermedades</span
              >
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h3 class="font-weight-bold m-0">
                {{ ges.total_diseases }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-ms-3 ml-3 p-2 card-color orange">
        <img
          class="centerImg1 ml-2 mt-2"
          src="@/assets/images/icons/security.svg"
        />
        <div class="align-items-center mt-1">
          <div class="row">
            <div class="col">
              <span class="table-value" style="font-size: 1.4rem"
                >IPT Requeridas por GES</span
              >
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h3 class="font-weight-bold m-0">
                {{ ges.ipts }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-ms-3 ml-2 p-2 card-color red">
        <img
          class="centerImg1 ml-2 mt-2"
          src="@/assets/images/icons/help_outline.svg"
        />
        <div class="align-items-center mt-1">
          <div class="row">
            <div class="col">
              <span class="table-value" style="font-size: 1.4rem"
                >Caracterización GES</span
              >
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h3 class="font-weight-bold m-0">
                {{
                  ges.characterization_code == null
                    ? "Sin Asignar"
                    : ges.characterization_code
                }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3 MODAL CREACIÓN y EDICION GES-->
    <ModalCreateGES
      :loading="loading"
      :titleModalGes="titleModalGes"
      :optionsSVE="optionsSVE"
      :record="record"
      @updateTable="updateTable"
    />

    <!-- 4 MODAL Confirmación-->
    <modal-confirm :loading="loading2" @deleteItem="deleteGes" :confirmation="confirmation" />

    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" :getUsersNotAdded="getUsersNotAdded" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import ModalCreateGES from "../../modals/ModalCreateGES.vue";
import ModalConfirm from "../../modals/ModalConfirm.vue";
import ModalSuccess from "../../modals/ModalSuccess";
import ModalError from "../../modals/ModalError";

export default {
  components: {
    OverlayButton,
    ModalCreateGES,
    ModalConfirm,
    ModalSuccess,
    ModalError
  },
  props: {
    getProcessingEmployees: {
      type: Boolean,
      default: false,
    },
    isVisible: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      titleModalGes: "Editar GES",
      optionsSVE: [],
      messageModal: "",
      confirmation: {},
      record: null,
    }
  },
  computed: {
    ...mapState("modSVE", ["ges", "loading", "loading2", "error"]),
    ...mapGetters("htGes", ["getUsersNotAdded"]),
  },
  methods: {
    ...mapActions("modSVE", ["actGetSVElist", "actDeleteGES"]),
    editGes() {
      const me = this;
      me.titleModalGes = "Editar GES";
      me.record = {
        id: me.ges.id,
        nameGES: me.ges.name,
        selectedGES: {
          id: me.ges.type,
          name:
            me.ges.type === "administrative"
              ? "GES Administrativo"
              : "GES Operativo",
        },
        sve: {
          id: me.ges.sve_id,
          name: me.ges.sve,
        },
      };
      me.$bvModal.show("modal-create-ges");
    },
    listSVE() {
      const me = this;
      me.actGetSVElist().then(() => {
        me.sveList.map((x) => {
          me.optionsSVE.push({
            id: x.id,
            name: x.name,
          });
        });
      });
    },
    updateTable() {
      const me = this;
      me.$emit("updateGES");
    },
    deleteGes() {
      const me = this;
      me.actDeleteGES(me.ges.id).then(() => {
        if (me.error.message) {
          me.$bvModal.hide("modal-confirm");
          me.$bvModal.show("modal-fail");
        } else {
          me.messageModal = `Has Borrado el GES ${me.ges.name}`;
          me.$bvModal.hide("modal-confirm");
          me.$bvModal.show("modal-success");
          me.$router.push("/sve");
        }
      });
    },
    deleteItem() {
      const me = this;
      me.confirm("delete");
    },
    confirm(x) {
      const me = this;
      if (x == "delete") {
        me.confirmation = {
          type: x,
          text: `¿Estás seguro de eliminar el GES ${me.ges.name}?`,
        };
        me.$bvModal.show("modal-confirm");
      }
    },
  }
};
</script>

<style lang="scss">
.infoGES {
  background: #ffffff;
  border: 1px solid #cfd8dc;
  border-radius: 8px;
}
.numbersGES {
  justify-content: space-between;
  p {
    font-size: 12px;
  }
}
.regular {
  border: none !important;
}
.linea {
  margin-top: 10px;
  border-top: 1px solid #cfd8dc;
  border-image-slice: 1;
}
.button-delete {
  border: 1px solid #da1414;
  background-color: transparent;
  color: #da1414;
  display: flex;
  align-items: center;
}
.button-delete img {
  margin-left: 5px;
}
.button-delete:hover {
  background-color: #eed4d4;
}
</style>
